module.exports = __webpack_public_path__ + "media/images/home/leadmatick-white-small-a997e38db01b600678bf2ac15413a64a.png";